import ActionTypes from '../constants/actionTypes';
import makeActionCreator from './actionCreators';

export const updateCurrentTime = makeActionCreator(
  ActionTypes.UPDATE_CURRENT_TIME,
  ['currentTime']
);
